import { useEffect } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';
import { useSelector } from 'react-redux';
import { AppState } from '~/reducers';
import { useAnalytics } from './use-analytics';

const useRouterAnalytics = () => {
  const onWebView = useSelector((state: AppState) => state.native.onWebView);
  const { logEvent } = useAnalytics();
  const location = useLocation();
  useEffect(() => {
    if (!onWebView) {
      logEvent('page_view', {
        page_title: document.title,
        page_location: location.pathname,
        language: navigator.language,
      });
    }
  }, [location, logEvent, onWebView]);
};

export { useRouterAnalytics };
